import { SyllabaryHangulIcon } from './SyllabaryHangulIcon';

/**
 * author: Haley Halcyon
 * id 9201098E-A360-4BF2-8EC7-683EB2AA7FEF
 * name syllabary-hangul
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/syllabary-hangul.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemHangulIcon = SyllabaryHangulIcon;
export default WritingSystemHangulIcon